import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { Enterprise } from 'models/Enterprises';
import { getEnterpriseRoute } from 'utils';

/**
 * Regular enterprise members (neither enterprise head nor office manager) may
 * only access a single enterprise page: the analytics overview outside RWC, and
 * suggested actions within RWC, where the overview holds nothing for them. When
 * such a member lands on any other subroute (deals, team, configuration,
 * branding) this returns the route to redirect them to; otherwise it returns an
 * empty string.
 */
export default function useRegularMemberHomeRedirect(
  enterprise: Enterprise,
  isRwc: boolean,
) {
  const { isRegularEnterpriseMember } = useContext(CurrentUserContext);

  const { pathname } = useLocation();

  if (!isRegularEnterpriseMember || !enterprise) return '';

  const { isDemo, _id } = enterprise;

  const homeRoute = isRwc
    ? `${getEnterpriseRoute(true, isDemo, _id)}/suggested-actions`
    : getEnterpriseRoute(false, isDemo, _id, 'analytics');

  return pathname === homeRoute ? '' : homeRoute;
}
